import React from 'react';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import SubnavTabs from '../subnav_tabs/SubnavTabs';

type LifeCycleAnalyticsOverviewHeaderProps = {
	companyConfig: any;
};

const LifeCycleAnalyticsOverviewHeader = ({
	companyConfig,
}: LifeCycleAnalyticsOverviewHeaderProps) => {
	return (
		<div
			className="-mx-2 mb-2 px-6 pb-0 pt-6"
			style={{
				background: nullSafeGet('detail.config.theme.navblock', companyConfig),
			}}
		>
			<div className="mb-6">
				<h4 className="mb-0 mr-2 text-white/90">Life Cycle Analytics</h4>
			</div>
			<SubnavTabs tabs={[]} onChange={() => {}} isActive={() => {}} />
		</div>
	);
};

export default LifeCycleAnalyticsOverviewHeader;
